export const chatBotConfig = {
    name: 'Chatbot',
    image: 'https://cdn.zappy.app/683d4d9709176b3ffc021133978a2e08.png',
    category: 'Zapier Blocks',
    inputs: [
        { type: 'string', name: 'chatbotID', required: true },
        { name: 'popup', type: 'boolean' },
        {
            name: 'height',
            type: 'number',
            helperText: 'The height of the chat window in pixels. We recommend not going below 300px to avoid cutting off key elements of the chatbot. Default is 600 if none is provided.',
        },
        {
            name: 'width',
            type: 'number',
            helperText: 'The width of the chat window pixels. We recommend not going below 300px to avoid cutting off key elements of the chatbot. Default is 400 if none is provided.',
        },
    ],
};
//# sourceMappingURL=config.js.map